import { render, staticRenderFns } from "./BlogSettings.vue?vue&type=template&id=37e4b506&scoped=true&"
import script from "./BlogSettings.vue?vue&type=script&lang=js&"
export * from "./BlogSettings.vue?vue&type=script&lang=js&"
import style0 from "./BlogSettings.vue?vue&type=style&index=0&id=37e4b506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e4b506",
  null
  
)

export default component.exports